import { memo, useEffect, useRef, useState } from 'react';

import s from './style.module.scss';
import { Display } from '@/components/Display/Display';

import { Tooltip } from 'antd';

import MyIcon from '@/components/MyIcon';
import allSkilllImg from '@/assets/images/web/all_skill.webp';
import { changeHorizonDomIntoView } from '@/utils/Page';
import { moreSkillImg } from '@/utils/Page/constant';
import { inject, observer } from 'mobx-react';
const SkillList = (props) => {
    let { store, themeColor = 1 } = props;
    const { skillList = [], curSkill = {} } = props;
    const [visible, setVisible] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const boxRef = useRef(null);
    const moreRef = useRef(null);

    useEffect(() => {
        const dom = boxRef.current;
        const isOverflowing = dom.offsetWidth < dom.scrollWidth;
        setShowMore(isOverflowing);
    }, [skillList]);
    const toggleMask = () => {
        setVisible(!visible);
    };

    const closeMask = () => {
        setVisible(false);
    };
    const changeScroll = (key) => {
        let dom = document.getElementById(key);
        if (!dom) {
            return false;
        }
        changeHorizonDomIntoView(dom, boxRef.current);
    };
    const handleSetCurSkill = (item, from = 'list') => {
        if (props.setCurSkill) {
            props.setCurSkill(item);
        }
        if (from === 'mask') {
            changeScroll(item.ability_id);
        }
        closeMask();
    };
    //点击弹窗以外的部分，关闭弹窗
    const clickGap = (e) => {
        //如果弹窗未打开，不做任何操作
        if (!moreRef.current) {
            return false;
        }
        //日期组件点击年份的时候，contains不生效，所以在wrapRef上阻止了冒泡
        if (moreRef.current && !moreRef.current.contains(e.target)) {
            closeMask();
        }
    };
    useEffect(() => {
        changeScroll(curSkill?.ability_id);
    }, [curSkill?.ability_id]);
    useEffect(() => {
        document.body.addEventListener('click', clickGap);
        return () => {
            document.body.removeEventListener('click', clickGap);
        };
    }, []);
    return (
        <div className={s['skill-box']} data-show={props.show} style={{ visibility: props.show ? 'initial' : 'hidden' }}>
            <Display show={visible}>
                <div ref={moreRef} className={s['more-skill-box']}>
                    <div className={s['mask-wrap']}>
                        <div className={s['mask-title']}>
                            <span>
                                <img src={allSkilllImg} alt="" />
                            </span>
                            <span className={s['close']} onClick={closeMask}>
                                <MyIcon type="icon-a-guanbi31"></MyIcon>
                            </span>
                        </div>
                        <div className={s['mask-list-box']}>
                            {skillList &&
                                skillList.map((item, index) => {
                                    return (
                                        <div className={s['mask-list-item']} key={index} onClick={() => handleSetCurSkill(item, 'mask')}>
                                            {item.ability_name}
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
            </Display>

            <div ref={boxRef} className={s['list-box']}>
                {skillList.map((item, index) => {
                    return (
                        <div
                            id={item.ability_id}
                            className={s['list-item']}
                            data-active={curSkill?.ability_id === item.ability_id}
                            key={index}
                            onClick={() => handleSetCurSkill(item)}
                        >
                            {item.ability_name}
                        </div>
                    );
                })}
            </div>
            <Display show={props.show && showMore}>
                <div
                    data-open={visible}
                    onClick={(e) => {
                        e.stopPropagation();
                        toggleMask();
                    }}
                    className={s['more']}
                >
                    <Tooltip title="全部技能">
                        <img src={moreSkillImg[themeColor]} alt="" />
                    </Tooltip>
                </div>
            </Display>
        </div>
    );
};

export default inject('store')(observer(SkillList));
